// directusErrorHandler.ts

import directus from '@/api/clients/directus-client'
import keycloak from '@/keycloak'
import store from '@/store/store'
import { ActionTypes } from '@/store/store_types'
import { checkToken } from './auth-calls'

export enum DirectusErrorCode {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  BAD_REQUEST = 400,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  GATEWAY_TIMEOUT = 504,
  SERVICE_UNAVAILABLE = 503,
  BAD_GATEWAY = 502,
}

export function handleDirectusError(error: any) {
  const errorCode = error?.status

  switch (errorCode) {
    case DirectusErrorCode.UNAUTHORIZED:
    case DirectusErrorCode.FORBIDDEN:
      // Check if still logged in. If not, trigger logout process
      checkIfStillAuthorized('session_expired')
      // Trigger session expired notification
      // TODO: Add session expired notification
      break
    case DirectusErrorCode.BAD_REQUEST:
    case DirectusErrorCode.TOO_MANY_REQUESTS:
    case DirectusErrorCode.INTERNAL_SERVER_ERROR:
    case DirectusErrorCode.GATEWAY_TIMEOUT:
    case DirectusErrorCode.SERVICE_UNAVAILABLE:
    case DirectusErrorCode.BAD_GATEWAY:
      // Check if still logged in. If not, trigger logout process
      checkIfStillAuthorized('server_error')
      // Trigger error notification
      // TODO: Add error notification
      break
    default:
      // Check if still logged in. If not, trigger logout process
      checkIfStillAuthorized('catch_all_error')
      // Trigger catch-all error notification
      // TODO: Add catch-all error notification
      break
  }
}

/**
 * Checks if the user is still authorized.
 * If not, triggers the logout process.
 */
async function checkIfStillAuthorized(logoutReason?: string) {
  // Check if the user is still authorized
  await directus.refresh().catch(async() => {
    // check for keycloak session
    if (keycloak.authenticated) {
      // attempt to re-establish keycloak and directus synced sessions
      const reEstablished = await checkToken()
      // if not re-established, trigger logout
      if (!reEstablished) {
        // compile redirect uri
        const redirectUri =
          window.location.origin +
          '/#/logout/' +
          (logoutReason ? new URLSearchParams('logout_reason=' + logoutReason).toString() : '')
    
        // Trigger logout process
        store.dispatch(ActionTypes.logoutUser, redirectUri)
      }
    }

  })
}
